import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { AuthService } from '../../services/auth.service';
import { MembershipsService } from '../../services/memberships.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as Cookies from 'js-cookie';
import { CommonHelper } from '../../helpers/common';
import { UserHelper } from '../../helpers/user';
import { NgForm } from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public user: UserModel = this.userHelper.getUser();
  public memberships: [];
  public isFromOrigin = true;
  public membershipUser = false;
  public formLogin: UserModel = new UserModel();

  constructor(
    private commonHelper: CommonHelper,
    private auth: AuthService,
    private userHelper: UserHelper,
    private membershipsService: MembershipsService,
    private router: Router,
    private route: ActivatedRoute) {
    //if(this.auth.isAuthenticate()) this.router.navigateByUrl('/player');

    if (this.route.snapshot.paramMap.get('affiliate_id') && this.route.snapshot.paramMap.get('affiliate_id') !== "") {//validamos la membresia para saber si es valida para ese país
      Cookies.set('affiliate_id', this.route.snapshot.paramMap.get('affiliate_id'));
    }

    if (this.user && this.user.memberships.length > 0) {//validamos que usuario tenga membresia pagada desde su token
      this.membershipUser = true;
    }

    //1.- obtenemos la ubicacion
    this.auth.geolocation().subscribe((resp) => {
      console.log(`Geo zona cliente  ${resp['response']['data'].name_en}`);

      if (resp['response']['data'].name_en.toLowerCase().indexOf('united states') !== -1) {
        //$('#modal-home-button').click();
      }
      if (resp['response']['data'].name_en.toLowerCase().indexOf('mexico') !== -1) {
        //$('#modal-home-mx-button').click();
      }
      //2.- obtenemos las membresias disponibles por país.
      this.membershipsService.getByCountry(resp['response']['data'].name_en).subscribe((membership) => {

        console.log(`Membresias para geo zona ${JSON.stringify(membership.id)}`);

        if (CommonHelper.storeLanguage == 'en') {
          membership.title = membership.title_en;
          membership.description = membership.description_en;
        };

        this.memberships = membership;

      }, (err) => {
        console.log("memberships exception:", err);
      });

    }, (err) => {
      console.log("geolocation exception:", err);
    });

  }

  ngOnInit() {
    const prevUrl = this.commonHelper.prevUrl;
    $(document).ready(function () {
      if (prevUrl !== '') {
        $('#modal-login').click();
      }
      function showcaseSection(element) {

        var otherElements = element.parents('.showcase-section').find('.showcase-feature'),
          elementTarget = $(element.attr('data-target')),
          otherTargets = element.parents('.showcase-section').find('.showcase-target');

        otherElements.removeClass('showcase-feature-active');
        element.addClass('showcase-feature-active');
        otherTargets.removeClass('showcase-target-active');
        elementTarget.addClass('showcase-target-active');

      }

      $('.showcase-feature').hover(function () {
        showcaseSection($(this));
      });


      $('#ytb-video').on('click', function (e) {
        e.preventDefault();

        if ($(this).hasClass('video-played')) {
          $('#ytb-video').YTPPause();
        } else {
          $('#ytb-video').YTPPlay();
          $('.ytb-poster').stop(true, true).fadeTo("slow", 0);
        }

        $(this).toggleClass('video-played');
      });
    });

    this.route.queryParams
      .subscribe(params => {
        if (params.apple_login) {
          const decodedToken = jwt_decode(params.apple_login);
          if (decodedToken) {
            var message = "";
            var currentTime = Math.floor(Date.now() / 1000);
            if (decodedToken.exp > currentTime) { //token expired
              if (decodedToken.sub && decodedToken.email) {
                decodedToken.sub
                decodedToken.email
                const formData = new FormData();
                formData.append('id', decodedToken.sub);
                formData.append('email', decodedToken.email);
                this.auth.appleLogin(formData).toPromise().then(rest => {
                  window.location.href = '/home';
                }).catch(err => {
                  switch (err.status) {
                    case 401:
                      message = this.commonHelper.getTranslation('errors.emailIsRegistered');
                      break;

                    default:
                      message = this.commonHelper.getTranslation('errors.serverError');
                      break;
                  }
                  Swal.fire({
                    type: 'error',
                    title: 'Iniciar con Apple',
                    text: message
                  });
                })
              }
            } else {
              message = this.commonHelper.getTranslation('errors.tokenExpired');
              Swal.fire({
                type: 'error',
                title: 'Iniciar con Apple',
                text: message
              });
            }
          } else {
            console.log("token malformed")
          }
        }
      }
      );

  }

  scrolling(position) {

    if (location.pathname.substr(1) == "home" || location.pathname.substr(1) == "index") {
      var elmnt = document.getElementById(position);
      elmnt.scrollIntoView({ behavior: 'smooth' });
    } else {
      var myurl = position;
      this.router.navigateByUrl('/home').then(e => {
        if (e) {
          var element = document.getElementById(position);
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  openPage(path: string) {
    if (this.auth.isAuthenticate()) {
      if (this.user.hasMembership(this.memberships['id'])) {
        this.router.navigateByUrl('/profile');
      } else {
        this.router.navigateByUrl(path + this.memberships['id']);
      }
    } else {
      $('#modal-login').click();
      $('#displayLoginForm').click();
      this.commonHelper.prevUrl = path + this.memberships['id'];
    }
  }

  loginSubmit(form: NgForm) {
    if (form.invalid) {
      console.log('form no valido!')
      return;
    }
    this.commonHelper.doLogin(this.formLogin, this.auth, this.userHelper, this.router);
  }

  openRegisterForm() {
    $('#modal-login').click();
    $('#displayRegisterForm').click();
  }

  openRecoveryForm() {
    $('#modal-login').click();
    $('#displayRecoveryForm').click();
  }

}

